import { Injectable } from '@angular/core';
import { SikoCart, SikoDeliveryOrderEntryGroup, SikoOccCart } from '@siko/models/cart.model';
import { SikoOccUtils } from '@siko/shared/utils/siko-occ-utils';
import { Cart } from '@spartacus/cart/base/root';
import { Converter, Occ } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class SikoOccCartNormalizer implements Converter<Occ.Cart, Cart> {
    constructor(private readonly occUtils: SikoOccUtils) {}

    convert(source: SikoOccCart, target?: SikoCart): SikoCart {
        if (target === undefined) {
            target = { ...(source as any) } as SikoCart;
        }

        if (source.pickupOrderGroups) {
            target.pickupOrderGroups = source.pickupOrderGroups.map((pickupOrderGroup: Occ.PickupOrderEntryGroup) => {
                return this.occUtils.convertOrderGroup(pickupOrderGroup, source.code);
            });
        }

        if (source.deliveryOrderGroups) {
            target.deliveryOrderGroups = source.deliveryOrderGroups.map(
                (deliveryOrderGroup: Occ.DeliveryOrderEntryGroup) => {
                    return this.occUtils.convertOrderGroup(deliveryOrderGroup, source.code);
                }
            );
        }

        if (source.undefinedOrderGroups) {
            target.undefinedOrderGroups = source.undefinedOrderGroups.map(
                (undefinedOrderGroup: SikoDeliveryOrderEntryGroup) => {
                    return this.occUtils.convertOrderGroup(undefinedOrderGroup, source.code);
                }
            );
        }

        return target;
    }
}
